export const generatePropertyTitle = (
  formData,
  attributeValues,
  config = {}
) => {
  const getLabel = (id) => {
    const item = attributeValues.find(
      (v) => String(v.id) === String(id)
    );

    return item?.label || id;
  };

  const formatName = (name) =>
    name
      ? String(name)
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : "";

  const {
    bhkKey = "bhkType",
    typeKey = "apartmentType",
    defaultTitle = "Property",
    postedFor = "",
  } = config;

  const bhk = getLabel(formData?.[bhkKey]);
  const type = getLabel(formData?.[typeKey]);

const city =
  formData?.villageName ||
  formData?.village_name ||
  formData?.location?.villageName ||
  formData?.location?.village_name ||
  formData?.village ||
  "";
  const titleParts = [];

  if (bhk) {
    titleParts.push(bhk);
  }

  if (type) {
    titleParts.push(type);
  }

  if (postedFor) {
    titleParts.push(`for ${postedFor}`);
  }

  if (city) {
    titleParts.push(`in ${formatName(city)}`);
  }

  return titleParts.join(" ") || defaultTitle;
};


export const generateFlatmatesTitle = (formData, attributeValues) => {
  const getLabel = (id) => {
    const item = attributeValues.find(v => String(v.id) === String(id));
    return item?.label || id;
  };

  const formatName = (name) =>
    name?.replace(/\b\w/g, (c) => c.toUpperCase());

  const roomType =
    formData?.roomType === "single"
      ? "Single Room"
      : formData?.roomType === "shared"
      ? "Shared Room"
      : "";

  const tenantType =
    formData?.tenantType
      ? formatName(formData.tenantType) 
      : "";

  const bhk = getLabel(formData?.bhkType);

  const location =
    formData?.villageName ||
    "Kanyakumari"; 

  const titleParts = [];

  if (roomType) titleParts.push(roomType);
  if (tenantType) titleParts.push(`for ${tenantType}`);
  if (bhk) titleParts.push(`in ${bhk}`);
  if (location) titleParts.push(`in ${formatName(location)}`);

  return titleParts.join(" ") || "Flatmates Property";
};




export const generatePGTitle = (formData, attributeValues = [], config = {}) => {
  const formatName = (name) =>
    name ? String(name).trim().replace(/\b\w/g, (c) => c.toUpperCase()) : "";

  // Debug — remove in production
  console.log("🔍 generatePGTitle input:", {
    formData,
    attributeValuesCount: attributeValues.length,
  });

  // --- 1. GET ROOM TYPE IDs ---
  let roomTypeIds = [];
  const rawRoomTypes =
    formData?.room_available_room_types ||
    formData?.attributes?.room_available_room_types ||
    formData?.selectedRoomTypes ||
    [];

  if (Array.isArray(rawRoomTypes)) {
    roomTypeIds = rawRoomTypes.map(String);
  } else if (typeof rawRoomTypes === "string") {
    roomTypeIds = rawRoomTypes.split(",").map((id) => String(id.trim()));
  }

  console.log("🔍 roomTypeIds:", roomTypeIds);

  // --- 2. MAP IDs → LABELS ---
  const roomTypeLabels = roomTypeIds
    .map((id) => {
      const attr = attributeValues.find(
        (a) =>
          String(a.id) === id ||
          String(a.value) === id ||
          String(a.attr_val_id) === id
      );
      return attr?.label || attr?.attr_val_name || null;
    })
    .filter(Boolean);

  console.log("🔍 roomTypeLabels:", roomTypeLabels);

  // --- 3. OPTIONAL: Map "Three" → "Triple" ---
  const ROOM_LABEL_MAP = {
    Single: "Single",
    Double: "Double",
    Three: "Triple",
    Triple: "Triple",
    Four: "Four",
  };

  const displayLabels = roomTypeLabels.map(
    (l) => ROOM_LABEL_MAP[l] || l
  );

  const sharingPrefix =
    displayLabels.length > 0
      ? `${displayLabels.join(", ")} Sharing `
      : "";

  // --- 4. GET LOCATION ---
  const location = formatName(
    formData?.villageName ||
      formData?.village_name ||
      formData?.location?.villageName ||
      formData?.location?.village_name ||
      "Kanyakumari"
  );

  // --- 5. FINAL TITLE ---
  const title = `${sharingPrefix}PG for ${location}`;
  console.log("🔍 Final title:", title);
  return title;
};


export const generatePlotTitle = (formData, config = {}) => {
  const formatName = (name) =>
    name?.replace(/\b\w/g, (c) => c.toUpperCase());

  const {
    postedFor = "Resale",
  } = config;

  const location = formData?.villageName || "Kanyakumari";
  const formattedLocation = formatName(location);

  // Fix: Add "Plot for" prefix
  return `Land/Plot for ${postedFor} in ${formattedLocation}`;
};